<div
  *ngIf="browserSupportAllFeatures
"
>
  <div class="page-container">
    <mat-toolbar>
      <mat-icon (click)="isExpanded = !isExpanded">menu</mat-icon>
      <div style="display: flex; flex-direction: column; position: relative">
        <div class="navbar-header" *ngIf="headerModel">
          <a class="site-title hidden-xs" [routerLink]="[]">
            {{ headerModel.siteTitle + (headerModel.testingMode ? ' - TESTING SITE' : '') }}
          </a>
          <app-breadcrumbs></app-breadcrumbs>
          {{headerModel.pageTitle}}
          <a class="navbar-link" *ngIf="headerModel.link" [routerLink]="headerModel.link.routeData">
            {{ headerModel.link.text}}
          </a>
        </div>
      </div>
      <div class="fill-remaining-space">
        <div *ngIf="headerModel.isRefreshing | async">
          <div class="spinner-border text-primary m-3 spinner-border-sm" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>
      <div class="logon-user">
        <span *ngIf="loggedIn && currentUser" style="padding: 15px">
          <em class="material-icons">person</em>
          {{ currentUser.name + (headerModel.user ? ' - ' + headerModel.user.cai : '') }}</span
        >
        <mat-icon *ngIf="!loggedIn" (click)="login()" style="position: relative; top: 5px"
          >login</mat-icon
        >
        <mat-icon class="circle" title="Logout" *ngIf="loggedIn" (click)="logout()"
          >logout</mat-icon
        >
      </div>
      <div class="company-logo"></div>
    </mat-toolbar>

    <mat-sidenav-container class="sidenav-container" autosize style="background-color: white">
      <mat-sidenav color="accent" #sidenav class="sidenav" mode="side" opened="true">
        <mat-nav-list class="dashboard">
          <a
            data-toggle="tooltip"
            title="Manifests"
            mat-list-item
            (click)="toggleActive($event)"
            routerLink="/manifests"
          >
            <mat-icon mat-list-icon>description</mat-icon>
            <p matLine *ngIf="isExpanded">Manifests</p>
          </a>
          <a
            data-toggle="tooltip"
            title="Containers"
            mat-list-item
            (click)="toggleActive($event)"
            routerLink="/containers"
          >
            <mat-icon mat-list-icon>inventory</mat-icon>
            <p matLine *ngIf="isExpanded">Containers</p>
          </a>
          <a
            data-toggle="tooltip"
            title="Items"
            mat-list-item
            (click)="toggleActive($event)"
            routerLink="/items"
          >
            <mat-icon mat-list-icon>widgets</mat-icon>
            <p matLine *ngIf="isExpanded">Items</p>
          </a>
          <mat-divider vertical style="height: 20px"></mat-divider>
          <a
            data-toggle="tooltip"
            title="Security"
            mat-list-item
            (click)="toggleActive($event)"
            routerLink="/security"
          >
            <mat-icon mat-list-icon>admin_panel_settings</mat-icon>
            <p matLine *ngIf="isExpanded">Security</p>
          </a>
          <a
            (click)="showSubmenu = !showSubmenu"
            class="parent"
            data-toggle="tooltip"
            title="Lists"
            mat-list-item
            (click)="toggleActive($event)"
          >
            <mat-icon mat-list-icon class="menu-button" [ngClass]="{'rotated' : showSubmenu}"
              >expand_more</mat-icon
            >
            <p class="full-width" matLine *ngIf="isExpanded || isShowing">Lists</p>
          </a>
          <div class="submenu" [ngClass]="{'expanded' : showSubmenu}">
            <a
              mat-list-item
              (click)="toggleActive($event)"
              data-toggle="tooltip"
              title="Container Type"
              routerLink="/containertypes"
            >
              <span mat-list-icon class="mat-list-icon">CT</span>
              <p matLine *ngIf="isExpanded">Container Type</p>
              <!-- <p matLine>Containers Type</p> -->
            </a>
            <a
              mat-list-item
              (click)="toggleActive($event)"
              title="Facilities"
              routerLink="/facilities"
            >
              <p mat-list-icon>FA</p>
              <p matLine *ngIf="isExpanded">Facilities</p></a
            >
            <a
              mat-list-item
              (click)="toggleActive($event)"
              title="Facilities Type"
              routerLink="/facilitytypes"
            >
              <p mat-list-icon>FT</p>
              <p matLine *ngIf="isExpanded">Facilities Type</p></a
            >
            <a
              mat-list-item
              (click)="toggleActive($event)"
              title="Form Codes"
              routerLink="/formcodes"
            >
              <p mat-list-icon>FC</p>
              <p matLine *ngIf="isExpanded">Form Codes</p>
            </a>
            <a
              mat-list-item
              (click)="toggleActive($event)"
              title="Materials"
              routerLink="/itemcontainermaterials"
            >
              <p mat-list-icon>MA</p>
              <p matLine *ngIf="isExpanded">Materials</p>
            </a>
            <a
              mat-list-item
              (click)="toggleActive($event)"
              title="Management Codes"
              routerLink="/managementcodes"
            >
              <p mat-list-icon>MC</p>
              <p matLine *ngIf="isExpanded">Management Codes</p></a
            >
            <a
              mat-list-item
              (click)="toggleActive($event)"
              title="Progress Catagories"
              routerLink="/processcategories"
            >
              <p mat-list-icon>PC</p>
              <p matLine *ngIf="isExpanded">Progress Catagories</p>
            </a>
            <a
              mat-list-item
              (click)="toggleActive($event)"
              title="Source codes"
              routerLink="/sourcecodes"
            >
              <p mat-list-icon>SC</p>
              <p matLine *ngIf="isExpanded">Source Codes</p>
            </a>
            <a
              mat-list-item
              (click)="toggleActive($event)"
              title="Transporters"
              routerLink="/transporters"
            >
              <p mat-list-icon>TR</p>
              <p matLine *ngIf="isExpanded">Transporters</p>
            </a>
            <a
              mat-list-item
              (click)="toggleActive($event)"
              title="TSDF Codes"
              routerLink="/tsdfcodes"
            >
              <p mat-list-icon>TC</p>
              <p matLine *ngIf="isExpanded">TSDF Codes</p>
            </a>
            <a mat-list-item (click)="toggleActive($event)" title="Units" routerLink="/units">
              <p mat-list-icon>UN</p>
              <p matLine *ngIf="isExpanded">Units</p>
            </a>
            <a
              mat-list-item
              (click)="toggleActive($event)"
              title="Waste Stream"
              routerLink="/wastestreams"
            >
              <p mat-list-icon>WS</p>
              <p matLine *ngIf="isExpanded">Waste Stream</p>
            </a>
          </div>
        </mat-nav-list>
      </mat-sidenav>
      <app-notifications></app-notifications>
      <div class="container-fluid" style="width: 100%; height: 100%">
        <router-outlet></router-outlet>
      </div>
    </mat-sidenav-container>
  </div>
</div>
